function serviceIcon({ id, name }) {
    if (typeof id === 'number') return `service_${id}`;

    console.error(`Missing service id (or wrong type) for service name "${name}". Won't display icon.`);
}

export {
    serviceIcon,
}